module.exports = __webpack_public_path__ + "static/rule.8cb58ad8.png";